var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDoubleArrowLeft = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64023 1.54842C9.80645 1.38218 9.80645 1.11269 9.64023 0.946454C9.47403 0.780299 9.20455 0.780299 9.03835 0.946454L5.63353 4.35131C5.46732 4.51751 5.46732 4.78699 5.63353 4.95319L9.03835 8.35801C9.20455 8.52422 9.47403 8.52422 9.64023 8.35801C9.80645 8.1918 9.80645 7.92233 9.64023 7.75612L6.53637 4.65225L9.64023 1.54842ZM4.53301 1.54842C4.69923 1.38218 4.69923 1.11269 4.53301 0.946454C4.36681 0.780299 4.09733 0.780299 3.93113 0.946454L0.526274 4.35131C0.360119 4.51751 0.360119 4.78699 0.526274 4.95319L3.93113 8.35801C4.09733 8.52422 4.36681 8.52422 4.53301 8.35801C4.69923 8.1918 4.69923 7.92233 4.53301 7.75612L1.42914 4.65225L4.53301 1.54842Z",
    fill: "#9BA5AE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoubleArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/double_arrow_left.42243a41.svg";
export { ForwardRef as ReactComponent };